/**
 * MARMonthNavigator.jsx
 */

import React from "react";
import dayjs from "dayjs";
import {
    Box,
    Button,
    IconButton,
    MenuItem,
    TextField,
    Grid
} from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export default function MARMonthNavigator({ selectedDate, onChangeDate }) {

    // Convert JS Date → Dayjs
    const safeDate = dayjs(selectedDate);

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const years = Array.from({ length: 10 }, (_, i) => 2020 + i);

    const monthIndex = safeDate.month();
    const year = safeDate.year();
    const day = safeDate.date();



    const goToday = () => onChangeDate(new Date());

    return (
        <Box sx={{ p: 2, borderBottom: "1px solid #ddd", mb: 2 }}>
            <Grid container spacing={2} alignItems="center">

                {/* Month Selector */}
                <Grid item>
                    <TextField
                        select
                        size="small"
                        label="Month"
                        value={months[monthIndex]}
                        onChange={(e) => {
                            const newMonth = months.indexOf(e.target.value);
                            onChangeDate(
                                dayjs(selectedDate)
                                    .month(newMonth)
                                    .date(day)
                                    .toDate()
                            );
                        }}
                    >
                        {months.map((m) => (
                            <MenuItem key={m} value={m}>
                                {m}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                {/* Year Selector */}
                <Grid item>
                    <TextField
                        select
                        size="small"
                        label="Year"
                        value={year}
                        onChange={(e) => {
                            onChangeDate(
                                dayjs(selectedDate)
                                    .year(Number(e.target.value))
                                    .toDate()
                            );
                        }}
                    >
                        {years.map((y) => (
                            <MenuItem key={y} value={y}>
                                {y}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                {/* Jump to Date */}
                <Grid item>
                    <DatePicker
                        label="Jump to Date"
                        value={safeDate}
                        onChange={(newVal) => {
                            if (!newVal) return;
                            onChangeDate(newVal.toDate()); // Dayjs → JS Date
                        }}
                    />
                </Grid>

                {/* Today Button */}
                <Grid item>
                    <Button variant="outlined" onClick={goToday}>
                        Today
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}
